import React from 'react';

import PropTypes from 'prop-types';

import { Box, TopbarWrapper } from './css';
import ServiceListRow from './serviceListRow';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const ServiceList = ({
  additionalServices,
  setAdditionalServices,
  setEditService,
  setIsFormTouched,
  editService
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    callCentre: {
      labelServices,
      tableHeader: { labelServiceName, labelPrice, labelQuantity, labelActions }
    }
  } = localizedStrings;

  const removeService = id => {
    const updatedServicesList = additionalServices.filter(
      service => service.id !== id
    );
    setAdditionalServices(updatedServicesList);
    setIsFormTouched(true);
  };
  return (
    <Box>
      <TopbarWrapper>{`${labelServices} (${additionalServices.length})`}</TopbarWrapper>
      <table className="responsive-table">
        <thead className="responsive-table__thead">
          <tr>
            <th>#</th>
            <th>{labelServiceName}</th>
            <th>{labelPrice}</th>
            <th>{labelQuantity}</th>
            <th>{labelActions}</th>
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {additionalServices.map((item, index) => {
            const { id } = item;
            if (editService && id === editService) return null;
            return (
              <ServiceListRow
                key={id}
                rowData={item}
                setEditService={setEditService}
                removeService={removeService}
                index={index}
              />
            );
          })}
        </tbody>
      </table>
    </Box>
  );
};

ServiceList.propTypes = {
  additionalServices: PropTypes.arrayOf(PropTypes.any).isRequired,
  setAdditionalServices: PropTypes.func.isRequired,
  setEditService: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.bool.isRequired,
  editService: PropTypes.string.isRequired
};

export default ServiceList;
